/**
 * Centralized query-key factories. Every resource registers its keys here.
 * Never inline ['products', id] in features.
 */
export const queryKeys = {
  product: {
    all: ['product'] as const,
    list: (filters?: Record<string, unknown>) => ['product', 'list', filters ?? {}] as const,
    filters: (categorySlug?: string, search?: string, locale?: string) =>
      ['product', 'filters', categorySlug ?? null, search ?? null, locale ?? null] as const,
    detail: (id: string) => ['product', 'detail', id] as const,
  },
  category: {
    all: ['category'] as const,
    tree: () => ['category', 'tree'] as const,
    detail: (slug: string) => ['category', 'detail', slug] as const,
  },
  cart: {
    all: ['cart'] as const,
    current: () => ['cart', 'current'] as const,
  },
  collection: {
    all: ['collection'] as const,
    list: (categorySlug: string, locale: string) =>
      ['collection', 'list', categorySlug, locale] as const,
    featured: (locale: string) => ['collection', 'featured', locale] as const,
    detail: (slug: string, locale: string) => ['collection', 'detail', slug, locale] as const,
    quote: (slug: string, selectedProducts: readonly number[], quantity: number, locale: string) =>
      ['collection', 'quote', slug, selectedProducts, quantity, locale] as const,
  },
  wishlist: {
    all: ['wishlist'] as const,
    current: () => ['wishlist', 'current'] as const,
  },
  slider: {
    all: ['slider'] as const,
    list: () => ['slider', 'list'] as const,
  },
  partner: {
    all: ['partner'] as const,
    list: () => ['partner', 'list'] as const,
  },
  pageSection: {
    all: ['page-section'] as const,
    list: (key: string) => ['page-section', 'list', key] as const,
  },
  news: {
    all: ['news'] as const,
    list: (page: number, pageSize: number) => ['news', 'list', page, pageSize] as const,
    detail: (slug: string) => ['news', 'detail', slug] as const,
  },
  contact: {
    all: ['contact'] as const,
    list: () => ['contact', 'list'] as const,
  },
  user: {
    all: ['user'] as const,
    me: () => ['user', 'me'] as const,
  },
  checkout: {
    all: ['checkout'] as const,
    shippingOptions: () => ['checkout', 'shipping-options'] as const,
    paymentOptions: () => ['checkout', 'payment-options'] as const,
  },
  account: {
    all: ['account'] as const,
    orders: (userId: string, page: number) => ['account', userId, 'orders', page] as const,
    order: (userId: string, id: string) => ['account', userId, 'order', id] as const,
  },
} as const;
